const ui = {
  namespaced: true,
  state: {
    // estado que almacena el nombre del componente renderizado
    bottomModalComponent: '',
    // esatdo que almacena las propiedades del componente dinamico
    bottomModalProperties: {},
    // estado que indica si se muestra el modal inferior
    bottomModalShow: false,
    // estado que almacena el titulo del modal inferior
    bottomModalTitle: '',
    showDialog: false,
    dialogTitle: '',
    dialogContent: '',
    dialogText: '',
    showAlert: false,
    alertMessage: '',
    alertType: 'success',
    showSidebar: false,
    showSideDialog: false,
    sideDialogTitle: '',
    sideDialogContent: '',
    sideDialogWidth: '40vw',
    // indica si mostrar las opciones del modal comun
    showModalOptions: true,
    // ancho del modla comun
    modalWidth: '100%',
    // estados para manejar el snackbar de la aplicación
    showSnackbar: '',
    snackbarTimeout: 2000,
    snackbarText: '',
    // reglas para la validadcion de campos en formularios
    inputRules: {
      requiredInput: (value) => {
        if (value === 0) {
          return true;
        }
        return !!value || 'El valor de este campo es obligatorio';
      },
      requiredSelect: (value) => !!value || 'Debe seleccionar un elemento de la lista',
      requiredMultiple: (value) => {
        const res = 'Debe seleccionar por lo menos un elemento de la lista';
        if (value === null || value === undefined) {
          return res;
        }
        if (value.length > 0) return true;
        return res;
      },
      min8: (v) => {
        const res = 'Minimo 8 caracteres';
        if (v === null || v === undefined) {
          return true;
        }
        if (v.length >= 8 || v.length === 0) {
          return true;
        }
        return res;
      },
      emailvalid: (v) => /.+@.+\..+/.test(v) || 'Debe ingresar un correo valido',
      isNumber: (v) => {
        const res = 'Debe ser un número';
        if (v === null || v === undefined || v === '') {
          return true;
        }
        const isNumber = Number(v);
        if (!Number.isNaN(isNumber)) {
          return true;
        }
        return res;
      },
      rangeNumber: (v, min, max) => {
        const res = `Debe ser un número entre ${min} y ${max}`;
        if (v === null || v === undefined || v === '') {
          return true;
        }
        const isNumber = Number(v);
        if (Number.isNaN(isNumber)) {
          return res;
        }
        if (v < min || v > max) {
          return res;
        }
        return true;
      },
      validDate: (value) => {
        const res = 'La fecha ingresada no tiene el formato YYYY-MM-DD';
        // eslint-disable-next-line
        const regex = /^\d{4}\-(0[1-9]|1[012])\-(0[1-9]|[12][0-9]|3[01])$/;
        if (value === null || value === undefined) {
          return true;
        }
        if (!regex.test(value)) {
          return res;
        }
        return true;
      },
      validDateTime: (value) => {
        const res = 'La fecha ingresada no tiene el formato YYYY-MM-DD';
        // eslint-disable-next-line
        const regex = /^\d{4}\-(0[1-9]|1[012])\-(0[1-9]|[12][0-9]|3[01])\s(0[0-9]|1[0-9]|2[0-3])\:\d{2}$/;
        if (value === null || value === undefined) {
          return true;
        }
        if (!regex.test(value)) {
          return res;
        }
        return true;
      },
      validPhone: (v) => /^\+?[0-9]{3,14}$/.test(v) || 'Debe ingresar un teléfono valido',
      validExt: (v) => {
        const res = 'La extensión solo puede tener de 3 a 5 dígitos';
        if (/^[0-9]{3,5}$/.test(v) || v.length === 0) {
          return true;
        }
        return res;
      },
      validRangeDate: (value) => {
        const res = 'EL rango de fechas ingresado no es válido';
        // eslint-disable-next-line
        const regex = /^\d{4}\-(0[1-9]|1[012])\-(0[1-9]|[12][0-9]|3[01])\s\~\s\d{4}\-(0[1-9]|1[012])\-(0[1-9]|[12][0-9]|3[01])$/;
        if (value === null || value === undefined) {
          return true;
        }
        if (!regex.test(value)) {
          return res;
          // eslint-disable-next-line
        } else {
          const [a, b] = value.split(' ~ ');
          if (a > b) {
            return 'La fecha de inicio no puede ser mayor que la fecha final';
            // eslint-disable-next-line
          } else {
            return true;
          }
        }
      },
      validCoordinate: (value) => {
        const res = 'La coordenada no tiene el formato adecuado';
        const regex = /^-?[0-9]{1,7}[,.]?[0-9]{0,6}$/;
        if (value === null || value === undefined) {
          return true;
        }
        if (!regex.test(value)) {
          return res;
        }
        return true;
      },
      validRangeDateCustom: (value) => {
        const res = 'EL rango de fechas ingresado no es válido';
        if (value === null || value === undefined) {
          return true;
        }
        if (value.length < 2) {
          return res;
        // eslint-disable-next-line
        } else {
          // eslint-disable-next-line
          if (value[0] > value[1]) {
            return 'La fecha de inicio no puede ser mayor que la fecha final';
            // eslint-disable-next-line
          } else {
            return true;
          }
        }
      },
      // egla para establecer criterios de una contraseña de django valida
      validDjangoPassword: (value) => {
        const res = `La contraseña debe tener de 8 caracteres,
          una letra mayúscula, una letra minúscula, al menos un dígito
          y al menos un caracter especial
        `;
        const regex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/;
        if (value === null || value === undefined) {
          return true;
        }
        if (!regex.test(value)) {
          return res;
        }
        return true;
      },
      // regla para campos que tiene que ver con creación de rutas en SO
      validSOPaths: (value) => {
        const res = `El valor de este campo no puede contener
        cualquiera de los siguentes caracteres: < > : " / \\ | ? *
        `;
        // eslint-disable-next-line
        const regex = /[<>:"\/\\|?*\x00-\x1F]/;
        if (value === null || value === undefined) {
          return true;
        }
        if (regex.test(value)) {
          return res;
        }
        return true;
      }
    },
    currentProperties: {},
    // estado que almacena el nombre del componente renderizado
    draggableModalComponent: '',
    // estado que indica si se muestra el modal inferior
    draggableModalShow: false,
    // estado que almacena el titulo del modal inferior
    draggableModalTitle: '',
    // esatdo que almacena las propiedades del componente dinamico
    draggableModalProperties: {},
    // estado con el ancho dinamico del modal drag
    draggableModalWidth: '400',
    draggableModalHeight: '500',
  },

  actions: {
    toggleDialog({rootState, commit, state}, status) {
      commit('TOGGLE_DIALOG', status);
      if (status === false) {
        // commit('folios/SELECT_MEASURE', null, { root: true });
        rootState.folios.selectedMeasure = null;
        rootState.folios.viewedMeasure = null;
        state.showModalOptions = true;
        state.currentProperties = {};
      }
    }
  },

  mutations: {
    TOGGLE_DIALOG(state, status) {
      if (status === false) {
        state.dialogText = '';
        state.showModalOptions = true;
        state.currentProperties = {};
      } 
      state.showDialog = status;
    },
    SET_DIALOG_CONTENT(state, componentName) {
      state.dialogContent = componentName;
    },
    SET_DIALOG_TEXT(state, text) {
      state.dialogText = text;
    },
    SET_DIALOG_TITLE(state, title) {
      state.dialogTitle = title;
    },
    SHOW_ALERT(state, {alertMessage, alertType}) {
      state.showAlert = true;
      state.alertMessage = alertMessage;
      state.alertType = alertType;
      setTimeout(() => state.showAlert = false, 5000);
    },
    TOGGLE_SIDEBAR(state, status) {
      state.showSidebar = status;
    },
    TOGGLE_SIDE_DIALOG(state, status) {
      if (status === false) {
        state.sideDialogTitle = '';
      } 
      state.showSideDialog = status;
    },
    SET_SIDE_DIALOG_CONTENT(state, componentName) {
      state.sideDialogContent = componentName;
    },
    SET_SIDE_DIALOG_TITLE(state, title) {
      state.sideDialogTitle = title;
    },
    SET_SIDE_DIALOG_WIDTH(state, width) {
      state.sideDialogWidth = width;
    },
    SHOW_BOTTOM_MODAL(state, {
      dialogTitle, componentName, properties
    }) {
      /**
       * Mutación para mostrar el modal inferior, para que el componente
       * se renderice debe ser importado en CommonBottonModal
       *
       * @param {Object} state con los elementos del estado del store
       * @param {Object}  payload los datos de la mutación
       * @returns {} No retorna nada
       * @example
       * $store.commit('ui/SHOW_BOTTOM_MODAL', {
       *  dialogTitle: '<title>',
       *  componentName: '<ComponentName>',
       * })
       * @author Luis Merizalde <luis.merizalde@arcerojas.com>
       */
      state.bottomModalComponent = componentName;
      state.bottomModalShow = true;
      state.bottomModalTitle = dialogTitle;
      state.bottomModalProperties = properties;
    },
    CHANGE_VALUE(state, { value, varName }) {
      /**
       * Mutación para cambiar el valor de un estado del store
       *
       * @param {Object} state con los elementos del estado del store
       * @param {Object}  payload los datos de la mutación
       * @returns {} No retorna nada
       * @example
       * $store.commit('ui/CHANGE_VALUE', {
       *  value: '<state_name>',
       *  varName: '<state_value>'
       * })
       * @author Luis Merizalde <luis.merizalde@arcerojas.com>
       */
      state[varName] = value;
    },
    CLEAR_BOTTOM_MODAL(state) {
      /**
       * Mutación para limpiar el modal
       *
       * @param {Object} state con los elementos del estado del store
       * @param {Object}  payload los datos de la mutación
       * @returns {} No retorna nada
       * @example
       * $store.commit('ui/CLEAR_BOTTOM_MODAL')
       * @author Luis Merizalde <luis.merizalde@arcerojas.com>
       */
      state.bottomModalShow = false;
      state.bottomModalComponent = '';
      state.bottomModalTitle = '';
      state.bottomModalProperties = {};
    },
    SHOW_SNACKBAR(state, { message }) {
      /**
       * Mutación para mostrar el snackbar
       *
       * @param {Object} state con los elementos del estado del store
       * @param {Object}  payload los datos de la mutación
       * @returns {} No retorna nada
       * @example
       * $store.commit('ui/CHANGE_VALUE', {
       *  message: '<state_name>',
       *  varName: '<state_value>'
       * })
       * @author Luis Merizalde <luis.merizalde@arcerojas.com>
       */
      state.showSnackbar = true;
      state.snackbarText = message;
    },
    SHOW_DRAGGABLE_MODAL(state, {
      dialogTitle, componentName, properties, width, height
    }) {
      /**
       * Mutación para mostrar el modal dragable, para que el componente
       * se renderice debe ser importado en DraggableDialog
       *
       * @param {Object} state con los elementos del estado del store
       * @param {Object}  payload los datos de la mutación
       * @returns {} No retorna nada
       * @example
       * $store.commit('ui/SHOW_DRAGGABLE_MODAL', {
       *  dialogTitle: '<title>',
       *  componentName: '<ComponentName>',
       *  properties: {
       *    prop1: val1,
       *    prop2: val2
       *  }
       * })
       * @author Luis Merizalde <luis.merizalde@arcerojas.com>
       */
      state.draggableModalComponent = componentName;
      state.draggableModalShow = true;
      state.draggableModalTitle = dialogTitle;
      state.draggableModalProperties = properties;
      state.draggableModalWidth = width;
      state.draggableModalHeight = height;
    },
  }
};
  
export default ui;